import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import iconCongratulations from '../../../assets/img/icon-congratulation.svg';
import iconAllDone from '../../../assets/img/ico-all-done.svg';

const Result = ({ user, validations, hanndleNextQuestion, items, response_range, section, prevState }) => {
  const [countdown, setCountdown] = useState(5);
  const btn_text = 'Next';
  const range_group_1 = response_range.get("1");
  const range_group_2 = response_range.get("2");
  const range_group_3 = response_range.get("3");

  let error_group_1 = null;
  let error_group_2 = null;
  let error_group_3 = null;

  if (!validations.group_1.valid && validations.group_1.error === 'min') {
    error_group_1 = <p className='text-danger mx-3 mx-md-3'><small>The minimum number for talents for the "Always" bucket is {range_group_1.min}. In the next screen, please add the strongest talent(s) from your "Sometimes" bucket.</small></p>;
  }

  if (!validations.group_1.valid && validations.group_1.error === 'max') {
    error_group_1 = <p className='text-danger mx-3 mx-md-3'><small>In the next screen, please select additional talents that aren't quite as strong and mark them as "Sometimes" to narrow the list down to your top {range_group_1.max}.</small></p>;
  }

  if (!validations.group_2.valid && validations.group_2.error === 'min') {
    error_group_2 = <p className='text-danger mx-3 mx-md-3'><small>The minimum number for talents for the "Sometimes" bucket is {range_group_2.min}. In the next screen, please add the talent(s).</small></p>;
  }

  if (!validations.group_2.valid && validations.group_2.error === 'max') {
    error_group_2 = <p className='text-danger mx-3 mx-md-3'><small>The maximum number for talents for the "Sometimes" bucket is {range_group_2.max}. In the next screen, please remove the talent (s) to your "Sometimes" bucket.</small></p>;
  }

  if (!validations.group_3.valid && validations.group_3.error === 'min') {
    error_group_3 = <p className='text-danger mx-3 mx-md-3'><small>The minimum number for talents for the "Never" bucket is {range_group_3.min}. In the next screen, please add the talent(s).</small></p>;
  }

  if (!validations.group_3.valid && validations.group_3.error === 'max') {
    error_group_3 = <p className='text-danger mx-3 mx-md-3'><small>The maximum number for talents for the "Never" bucket is {range_group_3.max}. In the next screen, please remove the talent (s) to your "Never" bucket.</small></p>;
  }

  const show_rearrenge = (section === 'result_1' || !validations.valid);
  const enabledCountdown = show_rearrenge && !user?.talents?.length;

  useEffect(() => {
    if (enabledCountdown) {
      const timer = setInterval(() => {
        setCountdown((prevCount) => {
          if (prevCount === 1) {
            clearInterval(timer);
            hanndleNextQuestion('rearrenge');
          }
          return prevCount - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [hanndleNextQuestion, enabledCountdown]);

  return (
    <>
      <div>
        <div className="text-center content-result">
          <div className='mb-3 pt-md-4'>
            <h2 className='mb-4 libre-caslon-text-regular h4-md h5'>Just one more step.</h2>
          </div>

          <div className='icon mb-4 d-inline-block text-white mx-auto'>
                <svg width="48" height="67" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.9128 5.94125L15.1328 1.64375C15.0493 1.18269 14.8066 0.765567 14.447 0.465157C14.0875 0.164747 13.6338 0.000120828 13.1653 0H6.83528C6.36673 0.000120828 5.91309 0.164747 5.55351 0.465157C5.19393 0.765567 4.95124 1.18269 4.86778 1.64375L4.08778 5.94125C2.82096 6.86868 1.79062 8.0817 1.08038 9.48189C0.370138 10.8821 0 12.43 0 14C0 15.57 0.370138 17.1179 1.08038 18.5181C1.79062 19.9183 2.82096 21.1313 4.08778 22.0588L4.86778 26.3563C4.95124 26.8173 5.19393 27.2344 5.55351 27.5348C5.91309 27.8353 6.36673 27.9999 6.83528 28H13.1653C13.6338 27.9999 14.0875 27.8353 14.447 27.5348C14.8066 27.2344 15.0493 26.8173 15.1328 26.3563L15.9128 22.0588C17.1796 21.1313 18.2099 19.9183 18.9202 18.5181C19.6304 17.1179 20.0006 15.57 20.0006 14C20.0006 12.43 19.6304 10.8821 18.9202 9.48189C18.2099 8.0817 17.1796 6.86868 15.9128 5.94125ZM6.83528 2H13.1653L13.654 4.69375C11.306 3.76878 8.69455 3.76878 6.34653 4.69375L6.83528 2ZM13.1653 26H6.83528L6.34653 23.3062C8.69455 24.2312 11.306 24.2312 13.654 23.3062L13.1653 26ZM15.0003 15H10.0003C9.73506 15 9.48071 14.8946 9.29317 14.7071C9.10564 14.5196 9.00028 14.2652 9.00028 14V9C9.00028 8.73478 9.10564 8.48043 9.29317 8.29289C9.48071 8.10536 9.73506 8 10.0003 8C10.2655 8 10.5199 8.10536 10.7074 8.29289C10.8949 8.48043 11.0003 8.73478 11.0003 9V13H15.0003C15.2655 13 15.5199 13.1054 15.7074 13.2929C15.8949 13.4804 16.0003 13.7348 16.0003 14C16.0003 14.2652 15.8949 14.5196 15.7074 14.7071C15.5199 14.8946 15.2655 15 15.0003 15Z" fill="#FF6F1F"/>
                </svg>
          </div>
          
          <p className='h5 font-weight-normal'>Now review and submit your answers</p>
                
          {!prevState &&
            <div className='mb-4'>
              <p className='h5-md h6 font-weight-normal'>You have identified the Thinking Talents that give you energy</p>
            </div>
          }

          <div className="d-flex justify-content-center">
            <div className="px-2 px-md-4 text-center">
              <div className={"rounded ttcard bg-always border " + (validations.group_1.valid ? 'border-always' : 'border-danger')}>
                <span className='text-capitalize h4 font-weight-normal d-block d-md-inline'>Always</span>
                <span className='d-block d-md-inline h4 ml-2 font-weight-bold libre-caslon-text-regular'>{items.group_1.size}</span>
              </div>
              {!validations.group_1.valid && <h6 className="text-danger"><small>{validations.group_1.message}</small></h6>}
            </div>
            <div className="px-2 px-md-4 text-center">
              <div className={"rounded ttcard bg-white border " + (validations.group_2.valid ? 'border-sometimes' : 'border-danger')}>
                <span className='text-capitalize h4 font-weight-normal d-block d-md-inline'>Sometimes</span>
                <span className='d-block d-md-inline h4 ml-2 font-weight-bold libre-caslon-text-regular'>{items.group_2.size}</span>
              </div>
              {!validations.group_2.valid && <h6 className="text-danger"><small>{validations.group_2.message}</small></h6>}
            </div>
            <div className="px-2 px-md-4 text-center">
              <div className={"rounded ttcard bg-never border " + (validations.group_3.valid ? 'border-never' : 'border-danger border')}>
                <span className='text-capitalize h4 font-weight-normal d-block d-md-inline'>Never</span>
                <span className='d-block d-md-inline h4 ml-2 font-weight-bold libre-caslon-text-regular'>{items.group_3.size}</span>
              </div>
              {!validations.group_3.valid && <h6 className="text-danger"><small>{validations.group_3.message}</small></h6>}
            </div>
          </div>
          {validations.valid &&
            <>
              <p className="mt-4 mb-2 small">On the next screen, you can review the talents you chose and rearrange them if you like.</p>
            </>
          }

          {error_group_1}
          {error_group_2}
          {error_group_3}

          <div className="text-center mt-auto">
            {show_rearrenge &&
              <Row>
                <Col md={{ size: 4, offset: 4 }}>
                  {enabledCountdown
                    ? <p className='text-muted'>
                      <small>
                        Redirecting to review & rearrange in {countdown}s
                      </small>
                    </p>
                    : <button onClick={() => hanndleNextQuestion('rearrenge')} className="btn btn-sm btn-green-light text-uppercase">{btn_text}</button>
                  }
                </Col>
              </Row>
            }
            {!show_rearrenge && <>
              <p className="h4 text-center text-reset">Tap Next to map your talents</p>
              <Row>
                <Col md={{ size: 4, offset: 4 }}>
                  <button onClick={() => hanndleNextQuestion('summary')} className="btn btn-sm btn-primary text-uppercase">{btn_text}</button>
                </Col>
              </Row>
            </>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Result;